import { Component, OnInit, ViewChild, ChangeDetectorRef, } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

import { CampaignModel } from 'src/app/models/CampaignModel';
import { RequestModel } from 'src/app/models/RequestModel';
import { RequestTreeModel } from 'src/app/models/RequestTreeModel';
import { CampaignService } from 'src/app/services/campaign.service';
import { Step1Component } from 'src/app/components/step1/step1.component';
import { Step2Component } from 'src/app/components/step2/step2.component';
import { Step3Component } from 'src/app/components/step3/step3.component';
import { Step4Component } from 'src/app/components/step4/step4.component';
import { GateKeeperComponent } from '../gate-keeper/gate-keeper.component';
import { CampaignTreeModel } from 'src/app/models/CampaignTreeModel';
import { TreesViewModel } from 'src/app/models/TreesViewModel';
import { updateTreeTotal } from 'src/app/shared/Calculations';

@Component({
    selector: 'app-form-frame',
    templateUrl: './form-frame.component.html',
    styleUrls: ['./form-frame.component.css']
})
export class FormFrameComponent implements OnInit {
    @ViewChild(GateKeeperComponent) private gateKeeperComponent: GateKeeperComponent;
    @ViewChild(Step1Component) private step1Component: Step1Component;
    @ViewChild(Step2Component) private step2Component: Step2Component;
    @ViewChild(Step3Component) private step3Component: Step3Component;
    @ViewChild(Step4Component) private step4Component: Step4Component;

    stepCount = 0;
    udcCount = 0;
    theEnd = false;
    isDbError = false;
    isBackButtonVisible = false;
    isNextButtonVisible = false;
    isWrong = false;

    campaign: CampaignModel = null;
    request: RequestModel = null;
    order: RequestModel = null;
    treesViewModel: TreesViewModel = null;

    stepCountMax = 4;
    params: Params;

    private udcCountMax = 5;

    constructor(
        private campaignService: CampaignService,
        public cdr: ChangeDetectorRef, // TODO: make it private
        private route: ActivatedRoute) { }

    ngOnInit(): void {
        if (this.stepCount > 0) {
            this.isNextButtonVisible = true; // for debugging TODO: remove
        }

        this.route.queryParams.subscribe((params: Params) => {
            this.params = params;
            console.log('App params', params);
            const id = params['CampaignId'];
            console.log('id', id);
            if (id) {
                this.getCampaign1(-id);
            }
            else {
                //this.getCampaign(3);
            }
        });
    }

    getCampaign1(campaignId: number): void {
        this.campaignService.getCampaign1(campaignId)
            .subscribe(
                campaign => this.onGetCampaign1(campaign as CampaignModel, campaignId),
                error => this.onError(error)
            );

    }

    onGetCampaign1 = (campaign: CampaignModel, id: number): void => {
        this.campaign = campaign;
        this.getCampaign(-id);

    }

    getCampaign(campaignId: number): void {
        this.campaignService.getCampaign(campaignId)
            .subscribe(
                campaign => this.onGetCampaign(campaign as CampaignModel),
                error => this.onError(error)
            );
    }



    onGetCampaign = (campaign: CampaignModel): void => {
        this.treesViewModel = new TreesViewModel();
        campaign.gatekeepers = this.campaign.gatekeepers;
        this.treesViewModel.campaign = campaign;
        this.treesViewModel.request = this.newRequest(campaign);
        this.campaign = campaign;
        this.request = this.treesViewModel.request;
    }
    onError(error: any) {
        this.campaign = null;
        this.isDbError = true;
    }


    back(): void {
        if (this.stepCount > 0) {
            this.updateModel(this.stepCount, this.stepCount === 1);
            this.isNextButtonVisible = true;
            this.stepCount--;
            if (this.stepCount === 0) {
                this.udcCount = this.campaign.gatekeepers.length - 1;
                this.cdr.detectChanges();
                this.gateKeeperComponent.reInitStep(this.udcCount);
                this.isNextButtonVisible = false;
            }
        }
        else {
            if (this.udcCount > 0) {
                this.udcCount--;
                this.gateKeeperComponent.reInitStep(this.udcCount);
                this.isBackButtonVisible = this.udcCount !== 0;
            }
            else {
                this.isBackButtonVisible = false;
                this.updateModel(this.stepCount);
            }
        }

        // if (this.stepCount === 1) {
        //     // this.isBackButtonVisible = false;
        //     // Back to gatekeeper
        //     this.updateModel(this.stepCount);
        //     this.stepCount--;

        // }
        this.cdr.detectChanges();
    }

    next(): void {
        if (this.stepCount > 0 && this.stepCount < this.stepCountMax) {
            if (this.updateModel(this.stepCount)) {
                this.stepCount++;
            }
        }

        if (this.stepCount > 0) {
            this.isNextButtonVisible = this.stepCount < this.stepCountMax;
        }

        if (this.stepCount > 1) {
            this.isBackButtonVisible = true;
        }

        if (this.stepCount === 0) {
            this.udcCount++;
            this.isNextButtonVisible = false;
            this.isBackButtonVisible = true;
            if (this.gateKeeperComponent.next(this.udcCount) !== true) {
                // this.isBackButtonVisible = true;
            }
            else {
                if (this.udcCount >= this.campaign.gatekeepers.length) {
                    this.stepCount++;
                    // this.isBackButtonVisible = true;
                    this.isNextButtonVisible = true;  // for now, TODO: remove
                }
            }
        }
        document.getElementById('appframe').scrollTop = 0;
        window.scrollTo(0, 0);
        this.cdr.detectChanges();
    }

    nextVisible(): boolean {
        if (this.stepCount === 1 && !this.step1Component) {
            return false;
        }
        if (this.stepCount === 1 && !this.step1Component.isValid()) {
            return false;
        }
        if (this.stepCount === 2 && !this.step2Component) {
            return false;
        }
        if (this.stepCount === 2 && !this.step2Component.isValid()) {
            return false;
        }
        if (this.stepCount === 3 && !this.step3Component) {
            return false;
        }
        if (this.stepCount === 3 && !this.step3Component.isValid()) {
            return false;
        }
        return this.isNextButtonVisible;
    }

    updateModel(n: number, isBack = false): boolean {
        switch (n) {
            case 1:
                if (!isBack && !this.step1Component.isValid()) {
                    this.step1Component.setTouched();
                    alert('Please fill in all required fields');
                    return false;
                }
                this.step1Component.saveRequest();
                if (!this.request.firstNameCard) {
                    this.request.firstNameCard = this.request.firstName;
                }
                if (!this.request.lastNameCard) {
                    this.request.lastNameCard = this.request.lastName;
                }
                // if (this.paymentPrep === null) {
                //     this.paymentPrep = this.initPayment(this.request);
                // }
                break;
            case 2:
                this.step2Component.saveRequest();
                this.updatePaymentAmount(this.request);
                break;
            case 3:
                this.step3Component.updateModel();
                break;
            case 4:
                this.step4Component.savePaymentPrep();
                break;
        }
        return true;
    }

    private updatePaymentAmount(request: RequestModel): void {
        let waitTotal = 0;
        let treesTotal = 0;
        let waitQtyTotal = 0;
        for (const tree of this.campaign.trees) {
            const total = updateTreeTotal(tree, this.request.neededTreeship, this.request.isTargetNeighborhood);
            tree.qty = tree.qty1 + tree.qty2 + tree.qty3 + tree.qty4;
            if (tree.isWaitlist === 1) {
                waitTotal += total;
                waitQtyTotal += tree.qty1 + tree.qty2 + tree.qty3 + tree.qty4;
            }
            else {
                treesTotal += total;
            }
        }
        request.treeTotalAmount = treesTotal;
        request.waitListAmount = waitTotal;
        // request.amountDueNow = treesTotal;
        request.waitQtyTotal = waitQtyTotal;
    }

    stepColor(index: number): string {
        return index === this.stepCount ? 'darkgreen' : '';
    }
    stepFormVisible(index: number): boolean {
        if (!this.request && index > 0) {
            return false;
        }
        return index === this.stepCount;
    }
    setPage(n: number): void {
        this.stepCount = n;
    }
    onAnswered(): void {
        this.isNextButtonVisible = true;
    }

    onPlaceOrder(): void {
        // this.isBackButtonVisible = false;
        this.updateModel(4);
        this.request.addTrees(this.campaign.trees);
        this.request.addUdfs(this.campaign);
        this.request.formWants(this.campaign)
        this.request.emailHtmlText(this.campaign)
        this.request.primaryPhone = this.request.primaryPhone.replace(/\D/g, '');
        if (this.request.alternativePhone) {
            this.request.alternativePhone = this.request.alternativePhone.replace(/\D/g, '');
            1
        }
        this.campaignService.placeOrder(this.request)
            .subscribe(order => {
                this.onEndPlace(order);
            });
    }
    private onEndPlace(order: RequestModel): void {
        this.request.mail = order.mail;
        this.request.customerPaymentProfileId = order.customerPaymentProfileId;
        this.request.customerProfileId = order.customerProfileId;
        if (order.profileResult.resultCode === 1 && order.chargeResult.resultCode === 1) {
            this.stepCount = 5;
        }
        else {
            this.step4Component.cardError(order);
        }
    }

    private newRequest(campaign: CampaignModel): RequestModel {
        const request = new RequestModel();
        request.requestId = 0;
        request.campaignId = campaign.campaignId;
        request.trees = [];
        for (const ctree of campaign.trees) {
            const tree = new RequestTreeModel();
            tree.requestId = request.requestId;
            tree.campaignTreeId = ctree.campaignTreeId;

            request.trees.push(tree);
        }
        request.displayTreeship = campaign.displayTreeship;
        return request;
    }
}
